/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 *
 **/
import { createIcon } from "@cmp-src/icons/create-icon";
export const ArrowDownIcon = createIcon({
  displayName: "ArrowDownIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5608 6.75011L9.23755 11.0733C8.55413 11.7568 7.44609 11.7568 6.76268 11.0733L2.43945 6.75011L3.50011 5.68945L7.82334 10.0127C7.92097 10.1103 8.07926 10.1103 8.17689 10.0127L12.5001 5.68945L13.5608 6.75011Z"
        fill="currentColor"
      />
    </g>
  )
});
